import React from 'react';

import type { Maybe } from 'src/common/types/Maybe';

export type PharmacyInfoDetails = {
  currentPharmacy: Maybe<string>;
  currentPharmacyNcpdpId: Maybe<string>;
  pharmacyUpdated: Maybe<boolean>;
};

type PharmacyInfoProps = {
  bridgeSubmissionDetails: PharmacyInfoDetails;
};

export const PharmacyInfo = ({ bridgeSubmissionDetails }: PharmacyInfoProps) => {
  const { currentPharmacy, pharmacyUpdated } = bridgeSubmissionDetails;

  if (!currentPharmacy) {
    return null;
  }

  return (
    <li>
      <span className="label">Pharmacy {pharmacyUpdated ? 'updated' : 'update requested'}:</span>{' '}
      {currentPharmacy}
    </li>
  );
};
